import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {Typeahead} from "react-bootstrap-typeahead";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {connect} from "react-redux";
import {Spinner} from "react-bootstrap";

class ExhibitionMapForm extends Component {

    state = {
        form: {
            id: null,
            networkDeviceIds: [],
            x: null,
            y: null,
            description: ''
        },
        selectedList: []
    };

    componentDidMount() {
        const { dispatch } = this.props;
        const { id, x, y } = this.props.data;

        dispatch(networkDeviceActions.getNetworkDeviceList());

        if(id) {
            this.setState({
                ...this.state,
                form: this.props.data
            });
        } else {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    x: x,
                    y: y,
                }
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.list !== this.props.list) {
            this.setState({
                ...this.state,
                selectedList: this.props.data.networkDevices
            });
        }
    }

    componentWillUnmount() {
        this.setState({
            form: {
                id: null,
                networkDeviceIds: [],
                x: null,
                y: null,
                description: ''
            },
            selectedList: []
        });
    }

    onChangeNetworkDeviceList = (networkDeviceList) => {
        this.setState({
            ...this.state,
            selectedList: networkDeviceList,
            form: {
                ...this.state.form,
                networkDeviceIds: networkDeviceList.map((item) => {
                    return item.id
                })
            }
        });
    };

    onSubmitForm = (e) => {
        e.preventDefault();
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t, list } = this.props;
        return (
            list ? (
                <React.Fragment>
                    <form onSubmit={this.onSubmitForm} >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="col-form-label">X</label>
                                    <input
                                        className='form-control'
                                        readOnly
                                        value={this.state.form.x || ''}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="col-form-label">Y</label>
                                    <input
                                        className='form-control'
                                        readOnly
                                        value={this.state.form.y || ''}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('network-devices')}</label>
                            <Typeahead
                                id="map-network-device"
                                labelKey={option => {
                                    return option.label || ""
                                }}
                                multiple
                                required
                                selected={this.state.selectedList}
                                onChange={ (selected) => this.onChangeNetworkDeviceList(selected) }
                                options={list}
                            />
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('description-more')}</label>
                            <textarea
                                value={this.state.form.description || ''}
                                className="form-control"
                                onChange={(e) => this.setState({
                                    ...this.state,
                                    form: {
                                        ...this.state.form,
                                        description: e.target.value
                                    }
                                })}
                            />
                        </div>

                        <div className="form-group float-right">
                            { this.state.form.id ? (
                                <button type="submit" className={"btn btn-primary" }>
                                    <i className="fas fa-edit"> </i> {t('edit')}
                                </button>
                            ) : (
                                <button type="submit" className={"btn btn-success" }>
                                    <i className="fas fa-plus"> </i> {t('create')}
                                </button>
                            ) }
                        </div>
                    </form>
                </React.Fragment>
                ) : (
                    <Spinner animation={"border"} />
                )
        )
    }
}

const mapStateToProps = (state) => {
    const { list } = state.networkDeviceReducer;
    return {
        list
    }
};

export default withNamespaces()(connect(mapStateToProps)(ExhibitionMapForm));
